import { Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { useNavState } from '../../navState/NavStateContext';
import { UsageList } from './UsageList';
import { WidgetCard } from './WidgetCard';

export const RecentlyUsedWidget = () => {
  const { readUsage } = useNavState();
  const readRecent = () =>
    readUsage()
      .sort((a, b) => b.lastUsed - a.lastUsed)
      .slice(0, 8);
  const [entries, setEntries] = useState(readRecent);

  return (
    <WidgetCard
      title="Recently Used"
      status={entries.length ? 'READY' : 'EMPTY'}
      emptyText="No recent activity"
      onRefresh={() => setEntries(readRecent())}
    >
      <UsageList
        entries={entries}
        renderMeta={(entry) => (
          <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'nowrap', ml: 1 }}>
            {DateTime.fromMillis(entry.lastUsed).toRelative()}
          </Typography>
        )}
      />
    </WidgetCard>
  );
};
